import { render, staticRenderFns } from "./BigArmyWxDialog.vue?vue&type=template&id=067d3a92&scoped=true&"
import script from "./BigArmyWxDialog.vue?vue&type=script&lang=ts&"
export * from "./BigArmyWxDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BigArmyWxDialog.vue?vue&type=style&index=0&id=067d3a92&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d3a92",
  null
  
)

export default component.exports